/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Lush_Gull_AskInputs */

const en_thin_lush_gull_ask = /** @type {(inputs: Thin_Lush_Gull_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing`)
};

const de_thin_lush_gull_ask = /** @type {(inputs: Thin_Lush_Gull_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere`)
};

/**
* | output |
* | --- |
* | "Importing" |
*
* @param {Thin_Lush_Gull_AskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_lush_gull_ask = /** @type {((inputs?: Thin_Lush_Gull_AskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Lush_Gull_AskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_lush_gull_ask(inputs)
	return de_thin_lush_gull_ask(inputs)
});